export const URLs = {

  newsletter: "dashboard/newsletters",
  contactUS: "dashboard/contacts",
  AdvertiseWithUs: "dashboard/advertises",
  ensebles: "ensembles",
  inquiries: "dashboard/inquiries",
  presenters: "presenters",
  subPages: "dashboard/pages",
  setPageVisible: "dashboard/pages/visible/",
  setSectionVisible: "dashboard/sections/visible/",
}







